import { render, staticRenderFns } from "./ver_reembolsos.vue?vue&type=template&id=b2dc3b26"
import script from "./ver_reembolsos.vue?vue&type=script&lang=js"
export * from "./ver_reembolsos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports